/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React from "react";
import FusionCharts from "fusioncharts";
import TimeSeries from "fusioncharts/fusioncharts.timeseries";
import RenderChart from '../charts/RenderChart'
import ReactFC from "react-fusioncharts";

import asyncCallHandler from '../../common/utils/asyncCallHandler'
import EDW_CONST from '../../common/constants';
import {tableDateFormatter, sortByKey} from '../../common/utils'
import { EDWDropDown } from "../common/dropDown/DropDown";
import { ErrorData } from "../common/noData/NoData";

import { AgGridReact } from 'ag-grid-react';
import styleM from '../../styles.module.scss';

import style from '../common/style/index.scss';

import EdwSwitchButton from '../common/edwSwitchButton/EdwSwitchButton'
import { EdwLoaderWithContainer } from '../common/edwLoaderWithContainer/EdwLoaderWithContainer'

ReactFC.fcRoot(FusionCharts, TimeSeries);

const dataSource = {
  chart: {
    
      
    },
  caption: {
   
  },
  subcaption: {
   
  },
  yaxis: [
    {
      plot: [
        {
          value: "Course target",
          type: "line",
          connectnulldata: true,
          //showGridband: false,
          style: {
            "plot": {
              "stroke-dasharray": "10",
                "stroke": "#820068"
            },
            "line": {
              "stroke-dasharray": "10",
                "stroke": "#820068"
            }
        }
      },
        {
          value: "Perfomance",
          type: "line",
          connectnulldata: true,
          //showGridband: false,
          style: {
            "plot.null": {
              "stroke-dasharray": "1",
            //    stroke: "#FF0000"
            }
        }
      },
        {
          value: "Group average",
          type: "line",
          connectnulldata: true,
          //showGridband: false,
          style: {
            "plot.null": {
              "stroke-dasharray": "1",
            //    stroke: "#FF0000"
            }
          }
      },
        {
          value: "Year average",
          type: "line",
          connectnulldata: true,
          //showGridband: false,
          style: {
            "plot.null": {
              "stroke-dasharray": "1",
            //    stroke: "#FF0000"
            }
          }
      }
      ],
      format: {
        //suffix: "%"
      },
      title: "Indicative grade"
    }
  ],
  datamarker: [
    
  ]
};

const statuscellClass = (params) => {
  return (params.value == 'Below') ? [style.fontCls, style.raRed].join(" ") : [style.fontCls].join(" ");
}

const columnDefinition = [
  {
    headerName: "Assessment",
    field: "assessmentName",
    sortable: true,
    minWidth: 300,
    unSortIcon: true,
    wrapText: true,
    autoHeight: true,
    sortingOrder: ['asc'],

  }
  , {
    headerName: "Academic year",
    field: "academicYear",
    sortable: true,
    minWidth: 50,
    unSortIcon: true,
    sortingOrder: ['asc'],
    cellClass: "centerCls",


  },
  {
    headerName: "Date",
    field: "assessmentDate",
    sortable: true,
    minWidth: 150,
    unSortIcon: true,
    sortingOrder: ['asc'],
    type: ['dateColumn', 'nonEditableColumn'],
    cellClass: "centerCls",
    valueFormatter: (params) => {
      return tableDateFormatter(params)
    }
  }


  , {
    headerName: "Mark",
    field: "assessmentScore",
    sortable: true,
    minWidth: 100,
    unSortIcon: true,
    sortingOrder: ['asc'],
    cellClass: "centerCls"
  },
  {
    headerName: "Indicative grade",
    field: "indicativeGrade",
    sortable: true,
    minWidth: 100,
    unSortIcon: true,
    sortingOrder: ['asc'],
    cellClass: "centerCls",
  }

  , {
    headerName: "On track",
    field: "onTrack",
    sortable: true,
    minWidth: 240,
    unSortIcon: true,
    sortingOrder: ['asc'],
    cellClass: statuscellClass,
  }
];

export class CourseTargetAndProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comparedItems: [],
      showChart: true,
      isDataLoaded: false,
      timeseriesDs: {
        type: "timeseries",
        renderAt: "container",
        width: "100%",
        customRangeSelector: '0',
        dataSource
      },
      studentData: props.studentData,
      showUnitTest: false
    };
  }

  componentDidMount() {
    this.fetchCourseTargetData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.groupId !== prevProps.groupId || this.props.courseId !== prevProps.courseId) {
      this.setState({comparedItems: [], showUnitTest: false, showChart: true});
      this.fetchCourseTargetData();
    }

    if(this.props.studentData !== prevProps.studentData){
      this.setState({})
    }

    if (this.state.showUnitTest !== prevState.showUnitTest) {
      this.sendData();
    }
    if (this.state.rowData !== prevState.rowData) {
      this.props.updateExportData({ type: "student_widget_1", rowData: this.state.rowData, columnDefs: columnDefinition });
    }
  }

  sendData = () => {
    let tableData = this.state.chartData[0].studentProgress;
    if (!this.state.showUnitTest) {
      tableData = tableData.filter(data => {
        if (data.assessmentTypeDescription.toLowerCase() != "unit test") return data;
      })
    }
    tableData.sort((e1, e2) => {
      return this.dateToNum(e2.assessmentDate) - this.dateToNum(e1.assessmentDate)
    });
    this.props.updateExportData({ type: "student_widget_1", rowData: tableData, columnDefs: columnDefinition });
  } 
  
  fetchCourseTargetData = () => {
    this.setState({ isDataLoaded: false})
    let { groupId, schoolId, studentId, courseId, token } = this.props;
    let apiEndPoint = `studentDetailsChart?studentId=${studentId}&groupId=${groupId}&schoolId=${schoolId}&courseId=${courseId}`
    let apiDomain = EDW_CONST.STUDENT_END_POINT;
    asyncCallHandler(apiDomain, apiEndPoint, token).then(data => {
      let timeSeriesConfig = this.getChartData(data.data, this.state.comparedItems, this.state.showUnitTest);
      this.setState({ chartData: data.data, isDataLoaded: true, timeseriesDs:timeSeriesConfig });
      this.sendData();
    }).catch((error) => {
      this.setState({ chartData: [], IsApiFail:true });
    });

  }

  switchView = () => {
    this.setState({  showChart: !this.state.showChart });

  }

  compareChart = (value) => {
    let timeseriesConfig = this.getChartData(this.state.chartData, value, this.state.showUnitTest)
    this.setState({ comparedItems: value, timeseriesDs: timeseriesConfig })
  }

   statuscellClass = (params) => {
    return (params.value == 'Below') ? [ style.fontCls, style.raRed].join(" ") : [style.fontCls].join(" ");
}

dateToNum(d) {
  d = d.split("-"); return Number(d[0] + d[1] + d[2]);
}

onSortChanged = (params) => {
    let sortModel = params.api.getSortModel();
    let sortedRowData = sortByKey(this.state.chartData[0].studentProgress, sortModel[0]["colId"]);
    this.setState({ rowData: sortedRowData });
  }  
  
  getTableView = () => {
    let tableData =  this.state.chartData[0].studentProgress;
    if(!this.state.showUnitTest){
      tableData = tableData.filter(data => {
        if(data.assessmentTypeDescription.toLowerCase() != "unit test") return data;
      })
    }
    tableData.sort((e1, e2) => {
      return this.dateToNum(e2.assessmentDate) - this.dateToNum(e1.assessmentDate)
    });
    let height = 120 + (parseInt(tableData.length)*50);
    return <div>
      <div >
          Baseline: <b>{this.props.studentData.baseGrade} </b>
          <br />
          Course target: <b>{this.props.studentData.targetGrade}</b>
          <br />
      </div>
    <div className="ag-theme-alpine" style={{
      height: height,  padding: '0px',
      position: 'relative'
    }} >
      <AgGridReact
        columnDefs={columnDefinition}
        rowData={tableData}
        onSortChanged={this.onSortChanged.bind(this)}
      />

    </div>
</div>
  }



  getChartData = (resData, compareList = [], showUnitTest) => {


    let studentProgress = resData[0].studentProgress? resData[0].studentProgress: []
    let courseTargetData = resData[0].courseTarget? resData[0].courseTarget: []
    if(studentProgress.length == 0 && courseTargetData.length == 0){
      return;
    }

        let timeseriesData = [], dataPoint = [];
        if(courseTargetData){
            courseTargetData.map(studentData => {
                let item = new Array(5);
                let dateVal = studentData.courseDate;
                let dateObj = dateVal.split('-');
                dateObj[1] = EDW_CONST.MONTHS[dateObj[1]]
                let dateFormated = dateObj.join('-');
                item[0] = dateFormated;
                item[1] = studentData.courseTargetGrade;
                item[2] = '';
                item[3] = '';
                item[4] = '';
                timeseriesData.push(item)
            })
        }


      if(studentProgress){
            studentProgress.map(studentData => {

              if(showUnitTest){

              
                let item = new Array(5);
                let dateVal = studentData.assessmentDate;

                let indicativeGrade = (studentData.indicativeGrade == 'U' || studentData.indicativeGrade == 'u')? '0.1': studentData.indicativeGrade;

                let dateObj = dateVal.split('-');
                dateObj[1] = EDW_CONST.MONTHS[dateObj[1]]
                let dateFormated = dateObj.join('-');
                item[0] = dateFormated;
                item[1] =  '';
                item[2] = indicativeGrade; //studentData.indicativeGrade;
                item[3] = studentData.groupAverageGrade;
                item[4] = studentData.yearAverageGrade;
                 if(compareList.indexOf('year') > -1 && compareList.length == 1){
                          item[3] = studentData.yearAverageGrade;
                    }

                dataPoint.push( {
                                //value: "Perfomance",
                                time: dateFormated,
                                timeformat: "%Y-%b-%d",
                                tooltext:  `Indicative grade: ${studentData.indicativeGrade} <br /> Assessment:  ${studentData.assessmentName} <br /> Assessment date: ${dateFormated}`
                              }
                          )

                    timeseriesData.push(item)

              }else{
                 if(studentData.assessmentTypeDescription.toLowerCase() != "unit test"){
                   let indicativeGrade = (studentData.indicativeGrade == 'U' || studentData.indicativeGrade == 'u')? '0.1': studentData.indicativeGrade;

                      let item = new Array(5);
                      let dateVal = studentData.assessmentDate;

                      let dateObj = dateVal.split('-');
                      dateObj[1] = EDW_CONST.MONTHS[dateObj[1]]
                      let dateFormated = dateObj.join('-');
                      item[0] = dateFormated;
                      item[1] =  '';
                      item[2] = indicativeGrade; //studentData.indicativeGrade;
                      item[3] = studentData.groupAverageGrade;

                      

                      item[4] = studentData.yearAverageGrade;

                      if(compareList.indexOf('year') > -1 && compareList.length == 1){
                          item[3] = studentData.yearAverageGrade;
                        }
                     
                      dataPoint.push( {
                                      //value: "Perfomance",
                                      time: dateFormated,
                                      timeformat: "%Y-%b-%d",
                                      tooltext: `Indicative grade: ${studentData.indicativeGrade} <br /> Assessment:  ${studentData.assessmentName} <br /> Assessment date: ${dateFormated}`
                                    }
                                )

                      timeseriesData.push(item)
                 }

                
              }
            })

      }


      const data = timeseriesData;
      
      const schema = [{
                        "name": "Time",
                        "type": "date",
                        "format": "%Y-%b-%d"
                        }, {
                        "name": "Course target",
                        "type": "number"
                        }, {
                        "name": "Perfomance",
                        "type": "number",
                        }
                    ]
            if(compareList.indexOf('group') > -1){
              schema.push({
                        "name": "Group average",
                        "type": "number",
                        "column": "Group average",
                         "index": 3
                        })
              
            }

            if(compareList.indexOf('year') > -1 && compareList.length == 2){
              schema.push({
                        "name": "Year average",
                        "type": "number",
                        "column": "Year average",
                         "index": 4
                        })
              
            }

            if(compareList.indexOf('year') > -1 && compareList.length == 1){
                          schema.push({
                        "name": "Year average",
                        "type": "number",
                        "column": "Year average",
                         "index": 3
                        })
                    }

      const fusionTable = new FusionCharts.DataStore().createDataTable(
        data,
        schema
      );

      const timeseriesDs = Object.assign({}, this.state.timeseriesDs);
    
      timeseriesDs.dataSource.data = fusionTable;

      timeseriesDs.dataSource.extensions = {
          "customRangeSelector": {
              "enabled": "0"
          },
          "standardRangeSelector": {
              "enabled": "0"
          }
      }

      timeseriesDs.dataSource.navigator = {
          "enabled": 0
      }

      timeseriesDs.dataSource.datamarker = dataPoint;


       timeseriesDs.dataSource.tooltip = {
          enabled: "1", 
          //outputTimeFormat: {} 
      }
      return timeseriesDs;


  }

 

  getChartView = () => {
      // return <ReactFC {...this.state.timeseriesDs} /> 
      return <RenderChart chartConfigs={this.state.timeseriesDs} fusionKey={this.props.fusionKey}/>        
  }

  showUnitTestChange = (event) => {
    let chartConfig = this.getChartData(this.state.chartData, this.state.comparedItems, event.target.checked);
      this.setState({ showUnitTest: event.target.checked, timeseriesDs: chartConfig });
  }


  render() {

    let switchProps = {
      leftLable: EDW_CONST.TABLE_VIEW,
      rightLable: EDW_CONST.GRAPH_VIEW,
      checked: this.state.showChart,
      handleChange: this.switchView
    }

    return (

      <div className="col">
        <div className="row">
          <div className="col-md-12">
            <span className="edw-widget-chart-title">Course target and progress</span>
          </div>
        </div>

        {(this.state.isDataLoaded && this.state.chartData.length > 0) &&
          <div className="row edw-widget-filter-area-adj content-row-padding">

           

            <div style={{flex: 1, marginRight: 20}}></div>
            <div style={{ marginRight: 20, marginTop: 44  }} className={[ styleM.customCheckbox].join(" ")}>
                                <input type="checkbox" id="colorblind" className="checkbox" value={this.state.showUnitTest} onChange={this.showUnitTestChange} checked={this.state.showUnitTest} />
                                <label for="colorblind">Show unit assessments</label>
            </div>
            
            <div style={{marginRight: 20}}>
              <label className="edw-widget-filter-lable" >Compare with</label>
              <EDWDropDown
                items={[
                  
                    
                     { id: 'group', label: this.props.studentData.groupName },
                      { id: 'year', label: 'Year '+ this.props.studentData.studentYear + ' ' + this.props.studentData.subjectName }
                     
                  
                ]}
                onChange={this.compareChart}
                multiple
                label="Select group/year"
                value={this.state.comparedItems}
              />
            </div>
            <div> <div className="edw-switch-btn-adj"><EdwSwitchButton {...switchProps} /></div></div>
          </div>
        }

        <div className="row">
          <div className="col-md-12">
           

            {this.state.showChart && <div className="edw-full-width margin-top-19">
                {

                  this.state.isDataLoaded && this.state.timeseriesDs ? (this.getChartView()) : (<EdwLoaderWithContainer />
                )
                }
              </div>
              }
              {!this.state.showChart && <div>
                {this.state.isDataLoaded ? (this.getTableView()) : ''}
              </div>
              }
          </div>
        </div>


        </div>

    );
  }
}


